import { PageHeader } from 'antd'
import React from 'react'
//import JcpReceiptList from '../../components/enrollment/jcp/JcpReceiptList'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PhysicallFitnessReceiptListComponent from '../../components/enrollment/physicallfitness/PhysicallFitnessReceiptListComponent'

const PhysicallFitnessReceiptList = () => {
  return (

<div>


<div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Physicall Fitness Enrollment List"
          subTitle=""
          
        ></PageHeader>

       
        <div className='tableView'>
          <div className="form-content">
              {/* <PhysicallFitnessReceiptList /> */}
              <PhysicallFitnessReceiptListComponent />
          </div>
        </div>

      </div>
    </div>

    </div>







  )
}

export default PhysicallFitnessReceiptList